<div class="container">
    <h1 class="page-title"> SOBRE NOSOTROS </h1>
    <p>Atlético Stats es Atleti, Periodismo y Datos.</p>
    <span>
        Atlético Stats es un proyecto en redes sociales sustentado sobre tres pilares fundamentales: Atleti + Periodismo + Datos. Un espacio para aquellos que buscan un contenido novedoso, fiable y de calidad, que ofrezca algo más allá de los medios tradicionales. Pretendemos contextualizar estadística y analíticamente la actualidad del Atlético de Madrid y explicar qué hay detrás de cada partido, jugador o decisión táctica, con la objetividad por bandera a través del dato.
        <br><br>Además, contamos con una marca fuerte, construida desde nuestros valores y con una apariencia gráfica muy trabajada, que nos convierte ya en referencia en nuestro sector.
        <br><br>Estamos hechos para las personas que quieren saber algo más allá de lo que puede leer en los medios tradicionales. Llevamos tres años al pie de la actualidad colchonera, creando contenido en directo en todos y cada uno de los partidos del Atlético de Madrid, hasta el punto de haber generado en el aficionado rojiblanco la costumbre de entrar a nuestras redes en cada previa y post partido para ver qué hemos compartido de dicho encuentro. Siempre desde el prisma del dato y lo diferencial de nuestro apartado gráfico.
    </span>
    
    <p>Empresas que han confiado en nosotros</p>
    <mat-card appearance="outlined">
        <mat-card-content>
            <div class="rumores-carousel">
                <div class="rumores-wrapper">
                    <img *ngFor="let member of sponsors" class="logos" [src]="member.img" srcset="{{member.img}} 480w, {{member.img}} 1024w, {{member.img}} 1600w" sizes="(max-width: 600px) 480px, (max-width: 1200px) 1024px, 1600px" [alt]="member.name"/>

                    <!-- Duplicamos el contenido para animación fluida -->
                    <img *ngFor="let member of sponsors" class="logos" [src]="member.img" srcset="{{member.img}} 480w, {{member.img}} 1024w, {{member.img}} 1600w" sizes="(max-width: 600px) 480px, (max-width: 1200px) 1024px, 1600px" [alt]="member.name"/>
                </div>
            </div>
        </mat-card-content>
    </mat-card>

    <p>Nuestro contenido</p>
    <mat-card appearance="outlined">
        <mat-card-content>
            <div class="responsive_table">
                <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
                    <!-- Position Column -->
                    <ng-container matColumnDef="logo">
                    <th mat-header-cell *matHeaderCellDef> Red Social </th>
                    <td mat-cell *matCellDef="let element"> 
                        <div style="display: flex; align-items: center;">
                            <img class="social-logo" src="{{element.logo}}" alt="{{element.name}} logo">
                        </div>
                    </td>
                    </ng-container>
                
                    <!-- Weight Column -->
                    <ng-container matColumnDef="follow">
                    <th mat-header-cell *matHeaderCellDef> Seguidores</th>
                    <td mat-cell *matCellDef="let element"> {{element.follow}} </td>
                    </ng-container>
                
                    <!-- Symbol Column -->
                    <ng-container matColumnDef="description">
                    <th mat-header-cell *matHeaderCellDef> ¿Qué hacemos? </th>
                    <td mat-cell *matCellDef="let element">
                        {{element.description}} 
                    </td>
                    </ng-container>
                
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row (click)="navigateTo(row.href)" *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
            </div>
        </mat-card-content>
    </mat-card>
      
      
    <p>Nuestro producto estrella: Atlético Stats On Tour</p>
    <span>Un reto de viajar
        a todos los partidos
        de visitante del
        Atlético de Madrid
        documentando la
        experiencia de vivir el
        fútbol fuera de casa.
    </span>
    <div class="iframe-container">
        <iframe 
            [src]="'https://www.youtube.com/embed/wllPDhJz3-M?si=RTNElL3S1EtQOSM-' | safeUrl" 
            frameborder="0" 
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
            allowfullscreen>
        </iframe>
    </div>

    <p>Nuestras 'stats'</p>
    <span>
        Somos de datos y los nuestros no están nada mal. Estadísticas de Atlético Stats en redes sociales mensualmente.
        <br><br>
    </span>
    <div class="influencia-img">
        <img src="assets/partners/Stats.png" alt="Estadísticas de Atlético Stats en redes">
    </div>
    
    <p>Reputación en el sector de la comunicación</p>
    <span>
        Esto opinan referentes del sector sobre nuestra serie Atlético Stats On Tour y el proyecto en general.
    </span>

    <div *ngFor="let cita of citas" class="quote-card">
        <div class="profile-pic">
          <img [src]="cita.img" alt="{{cita.name}}">
        </div>
        <div class="quote-content">
          <div class="name">{{cita.name}}</div>
          <div class="text">{{cita.text}}</div>
        </div>
    </div>

    <p-carousel
    [value]="influencia"
    [numVisible]="1"
    [numScroll]="1"
    [circular]="true"
    autoplayInterval="7000"
    class="custom-carousel"
    >
        <ng-template let-member let-index="index" pTemplate="item">
            <mat-card appearance="outlined" class="influencia">
                <mat-card-content>
                    <div class="influencia-img">
                        <img [src]="member.img" [alt]="member.name" />
                    </div>
                </mat-card-content>
            </mat-card>
        </ng-template>
    </p-carousel>

    <p>El equipo de Atlético Stats</p>
    <span>
        Atlético Stats está formado por un equipo joven, que aúna nuestra pasión por el Atleti y por el fútbol, con distintos roles muy específicos para el sector de la comunicación (datos, audiovisual, diseño gráfico...).
    </span>
    
    <span>Nuestro variado equipo de colaboradores:</span>
    <p-carousel
      *ngIf="members.length > 0"
      [value]="members"
      [numVisible]="numVisible"
      [numScroll]="1"
      [circular]="true"
      autoplayInterval="6000"
      class="custom-carousel"
    >
      <ng-template let-member let-index="index" pTemplate="item">
        <mat-card appearance="outlined" class="people-card">
            <mat-card-content>
                <a [href]="member.link" target="_blank">
                    <div class="foto">
                        <img [src]="member.img" [alt]="member.name"/>
                    </div>
                    <h2 class="title">{{ member.name }}</h2>
                    <p class="titular">{{ member.titular }}</p>
                    <p class="description">{{ member.description }}</p>
                </a>
            </mat-card-content>
        </mat-card>
      </ng-template>
    </p-carousel>

    <a *ngFor="let cita of owners" [href]="cita.link" target="_blank" class="quote-card">
        <div class="profile-pic">
          <img [src]="cita.img" alt="{{cita.name}}">
        </div>
        <div class="quote-content">
          <div class="name">{{cita.name}}</div>
          <div class="text">{{cita.text}}</div>
        </div>
    </a>

    <div class="content">
        <p>Mantente al tanto de todo nuestro contenido en nuestras redes sociales. ¡Síguenos!</p>
        <div class="social-links">
            <a href="https://x.com/atletico_stats_" target="_blank" class="social-link">
                <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100" viewBox="0 0 50 50">
                    <path d="M 50.0625 10.4375 C 48.214844 11.257813 46.234375 11.808594 44.152344 12.058594 C 46.277344 10.785156 47.910156 8.769531 48.675781 6.371094 C 46.691406 7.546875 44.484375 8.402344 42.144531 8.863281 C 40.269531 6.863281 37.597656 5.617188 34.640625 5.617188 C 28.960938 5.617188 24.355469 10.21875 24.355469 15.898438 C 24.355469 16.703125 24.449219 17.488281 24.625 18.242188 C 16.078125 17.8125 8.503906 13.71875 3.429688 7.496094 C 2.542969 9.019531 2.039063 10.785156 2.039063 12.667969 C 2.039063 16.234375 3.851563 19.382813 6.613281 21.230469 C 4.925781 21.175781 3.339844 20.710938 1.953125 19.941406 C 1.953125 19.984375 1.953125 20.027344 1.953125 20.070313 C 1.953125 25.054688 5.5 29.207031 10.199219 30.15625 C 9.339844 30.390625 8.429688 30.515625 7.492188 30.515625 C 6.828125 30.515625 6.183594 30.453125 5.554688 30.328125 C 6.867188 34.410156 10.664063 37.390625 15.160156 37.472656 C 11.644531 40.230469 7.210938 41.871094 2.390625 41.871094 C 1.558594 41.871094 0.742188 41.824219 -0.0585938 41.726563 C 4.488281 44.648438 9.894531 46.347656 15.703125 46.347656 C 34.617188 46.347656 44.960938 30.679688 44.960938 17.09375 C 44.960938 16.648438 44.949219 16.199219 44.933594 15.761719 C 46.941406 14.3125 48.683594 12.5 50.0625 10.4375 Z"></path>
                </svg>
                Twitter
            </a>
            <a href="https://www.linkedin.com/company/atleticostats" target="_blank" class="social-link">
                <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100" viewBox="0 0 50 50">
                    <path d="M41,4H9C6.24,4,4,6.24,4,9v32c0,2.76,2.24,5,5,5h32c2.76,0,5-2.24,5-5V9C46,6.24,43.76,4,41,4z M17,20v19h-6V20H17z M11,14.47c0-1.4,1.2-2.47,3-2.47s2.93,1.07,3,2.47c0,1.4-1.12,2.53-3,2.53C12.2,17,11,15.87,11,14.47z M39,39h-6c0,0,0-9.26,0-10 c0-2-1-4-3.5-4.04h-0.08C27,24.96,26,27.02,26,29c0,0.91,0,10,0,10h-6V20h6v2.56c0,0,1.93-2.56,5.81-2.56 c3.97,0,7.19,2.73,7.19,8.26V39z"></path>
                </svg>
                LinkedIn
            </a>
            <a href="https://twitch.tv/atletico_stats" target="_blank" class="social-link">
                <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100" viewBox="0 0 32 32">
                    <path d="M 6.5 5 L 5 9 L 5 25 L 10.5 25 L 10.5 28 L 13.5 28 L 16.5 25 L 21 25 L 27 19 L 27 5 Z M 9 7 L 25 7 L 25 18 L 22 21 L 16 21 L 13 24 L 13 21 L 9 21 Z M 14 11 L 14 17 L 16 17 L 16 11 Z M 19 11 L 19 17 L 21 17 L 21 11 Z"></path>
                </svg>
                Twitch
            </a>
            <a href="https://youtube.com/@atletico_stats" target="_blank" class="social-link">
                <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100" viewBox="0 0 50 50">
                    <path d="M 44.898438 14.5 C 44.5 12.300781 42.601563 10.699219 40.398438 10.199219 C 37.101563 9.5 31 9 24.398438 9 C 17.800781 9 11.601563 9.5 8.300781 10.199219 C 6.101563 10.699219 4.199219 12.199219 3.800781 14.5 C 3.398438 17 3 20.5 3 25 C 3 29.5 3.398438 33 3.898438 35.5 C 4.300781 37.699219 6.199219 39.300781 8.398438 39.800781 C 11.898438 40.5 17.898438 41 24.5 41 C 31.101563 41 37.101563 40.5 40.601563 39.800781 C 42.800781 39.300781 44.699219 37.800781 45.101563 35.5 C 45.5 33 46 29.398438 46.101563 25 C 45.898438 20.5 45.398438 17 44.898438 14.5 Z M 19 32 L 19 18 L 31.199219 25 Z"></path>
                </svg>
                YouTube
            </a>
            <a href="https://instagram.com/atletico_stats" target="_blank" class="social-link">
                <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100" viewBox="0 0 24 24">
                    <path d="M 8 3 C 5.239 3 3 5.239 3 8 L 3 16 C 3 18.761 5.239 21 8 21 L 16 21 C 18.761 21 21 18.761 21 16 L 21 8 C 21 5.239 18.761 3 16 3 L 8 3 z M 18 5 C 18.552 5 19 5.448 19 6 C 19 6.552 18.552 7 18 7 C 17.448 7 17 6.552 17 6 C 17 5.448 17.448 5 18 5 z M 12 7 C 14.761 7 17 9.239 17 12 C 17 14.761 14.761 17 12 17 C 9.239 17 7 14.761 7 12 C 7 9.239 9.239 7 12 7 z M 12 9 A 3 3 0 0 0 9 12 A 3 3 0 0 0 12 15 A 3 3 0 0 0 15 12 A 3 3 0 0 0 12 9 z"></path>
                </svg>
                Instagram
            </a>
        </div>
        
        <br>
        <span class="contact">
        ¿Quieres contactarnos? Escríbenos por email: <a href="mailto:comunicacion@atleticostats.es">comunicacion&#64;atleticostats.es</a>
        </span>
    </div>
</div>
